import React from 'react';
import { ButtonProps } from 'typings';

export const Button: React.FC<ButtonProps> = props => {
    return (
        <bds-button
            id={props.id}
            icon={props.icon}
            arrow={props.arrow}
            type={props.type}
            variant={props.variant}
            color={props.color}
            size={props.size}
            onClick={props.handleClick}
            disabled={props.disabled}
        >
            {props.text}
        </bds-button>
    );
};
